/**
 * @generated SignedSource<<a1b59c2a820062ff515dd43a688bdb40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalWorkItemSubtype = "APPROVAL" | "BUG" | "CATALOG_ITEM" | "DEFAULT_TASK" | "EPIC" | "INCIDENT" | "ISSUE" | "MILESTONE" | "OTHER" | "PROBLEM" | "QUESTION" | "REQUESTED_ITEM" | "SECTION" | "STORY" | "TASK" | "TICKET" | "WORK_ITEM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphJiraDcWorkItem_AtlassianSearchPage$data = {
  readonly entity: {
    readonly assignee?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly container?: {
      readonly displayName?: string | null;
      readonly url?: string | null;
    } | null;
    readonly createdBy?: {
      readonly thirdPartyUser: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly dueDate?: string | null;
    readonly status?: string | null;
    readonly subtype?: ExternalWorkItemSubtype | null;
    readonly team?: string | null;
  } | null;
  readonly excerpt: string | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly lastModifiedDate: string | null;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphJiraDcWorkItem_AtlassianSearchPage";
};
export type searchGraphJiraDcWorkItem_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphJiraDcWorkItem_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphJiraDcWorkItem_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = [
  {
    "concreteType": "ThirdPartyUser",
    "kind": "LinkedField",
    "name": "thirdPartyUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphJiraDcWorkItem_AtlassianSearchPage",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "excerpt"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v2/*: any*/)
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": (v2/*: any*/)
            },
            {
              "kind": "ScalarField",
              "name": "dueDate"
            },
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "subtype"
            },
            {
              "kind": "ScalarField",
              "name": "team"
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    },
                    (v1/*: any*/)
                  ],
                  "type": "ExternalSpace"
                }
              ]
            }
          ],
          "type": "ExternalWorkItem"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "e5918a4fc563b65267f6c7d5107c7fb8";

export default node;
